/* Fun Cases — theme.js
   Progressive enhancement only; the page is fully readable without it.
   Everything is delegated / re-initialisable so it survives Shopify's
   theme-editor section reloads. */

(function () {
  'use strict';

  /* ---- Mobile drawer (burger) ------------------------------------- */
  function initDrawer(root) {
    var burger = (root || document).querySelector('.burger');
    if (!burger || burger.dataset.bound) return;
    burger.dataset.bound = '1';
    burger.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- Best-sellers carousel arrows ------------------------------- */
  function initCarousels(root) {
    var tracks = (root || document).querySelectorAll('[data-bs-track]');
    tracks.forEach(function (track) {
      if (track.dataset.bound) return;
      track.dataset.bound = '1';
      var section = track.closest('section') || document;
      var prev = section.querySelector('[data-bs-prev]');
      var next = section.querySelector('[data-bs-next]');
      function page() {
        var cs = getComputedStyle(track);
        var pad = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
        var gap = parseFloat(cs.columnGap) || 8;
        return track.clientWidth - pad + gap;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });
    });
  }

  /* ---- Mega: hover a rail item to reveal its L3 group -------------- */
  function initMega(root) {
    var rails = (root || document).querySelectorAll('[data-mega-rail]');
    rails.forEach(function (rail) {
      if (rail.dataset.bound) return;
      rail.dataset.bound = '1';
      var mega = rail.closest('.mega');
      if (!mega) return;
      var groups = mega.querySelectorAll('[data-mega-group]');
      function show(idx) {
        groups.forEach(function (g) {
          g.classList.toggle('active', g.getAttribute('data-mega-group') === String(idx));
        });
      }
      rail.querySelectorAll('[data-mega-idx]').forEach(function (a) {
        var idx = a.getAttribute('data-mega-idx');
        a.addEventListener('mouseenter', function () { show(idx); });
        a.addEventListener('focus', function () { show(idx); });
      });
    });
  }

  /* ---- Predictive search ------------------------------------------ */
  function esc(s) {
    return (s == null ? '' : '' + s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  /* Shopify's predictive search appends ?variant=<id> to product results: the product's FIRST
     variant, which on a phone case is an arbitrary model (usually Galaxy A12). The PDP treats any
     ?variant deep link as the shopper's chosen phone, opens on it and writes it back as their saved
     model site-wide, so one click on a result silently switched them to the A12. Dropping the
     param lets the PDP open on the shopper's own saved model. Shopify's _pos/_psq/_ss search
     analytics params are kept. Ad and feed deep links are untouched: they don't come through here. */
  function psUrl(u) {
    try {
      var x = new URL(u, location.origin);
      x.searchParams.delete('variant');
      return x.pathname + x.search + x.hash;
    } catch (e) {
      return (u || '').replace(/([?&])variant=[^&#]*(&|$)/, function (m, a, b) { return b ? a : ''; });
    }
  }
  function money(p) {
    var f = window.__fcMoney || '£{{amount}}';
    return f.replace(/\{\{\s*amount(?:_[a-z_]+)?\s*\}\}/, p);
  }

  function initPredictiveSearch(root) {
    var forms = (root || document).querySelectorAll('[data-ps-form]');
    forms.forEach(function (form) {
      if (form.dataset.psBound) return;
      form.dataset.psBound = '1';
      var input = form.querySelector('[data-ps-input]');
      var panel = form.querySelector('[data-ps-panel]');
      if (!input || !panel) return;
      var timer;

      function close() { panel.hidden = true; }
      function open() { if (panel.innerHTML) panel.hidden = false; }

      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { panel.innerHTML = ''; close(); return; }
        panel.innerHTML = '<div class="ps-loading"><span class="ps-spinner"></span>Searching&hellip;</div>';
        panel.hidden = false;
        timer = setTimeout(function () { run(q, panel); }, 200);
      });
      input.addEventListener('focus', open);
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  function run(q, panel) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = (data.resources && data.resources.results) || {};
        render(panel, q, res.products || [], res.queries || []);
      })
      .catch(function () { panel.hidden = true; });
  }

  function render(panel, q, products, queries) {
    var html = '';
    if (queries.length) {
      html += '<div class="ps-sep">Suggestions</div>';
      queries.slice(0, 4).forEach(function (x) {
        html += '<a class="ps-q" href="' + x.url + '">' + esc(x.text) + '</a>';
      });
    }
    if (products.length) {
      html += '<div class="ps-sep">Products</div>';
      products.forEach(function (p) {
        html += '<a class="ps-item" href="' + psUrl(p.url) + '">' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<span class="ps-noimg"></span>') +
          '<span class="ps-t">' + esc(p.title) + '</span>' +
          (p.price ? '<span class="ps-p">' + money(p.price) + '</span>' : '') +
          '</a>';
      });
    }
    if (!queries.length && !products.length) {
      html += '<div class="ps-sep">No matches</div>';
    }
    html += '<a class="ps-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results for &ldquo;' + esc(q) + '&rdquo; &rarr;</a>';
    panel.innerHTML = html;
    panel.hidden = false;
  }

  /* ---- Close drawer when viewport grows past mobile --------------- */

  /* ---- Collection filter slideout --------------------------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-open]')) {
      var d = document.querySelector('[data-filter-drawer]');
      if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('filter-open'); }
      return;
    }
    if (e.target.closest('[data-filter-close]')) {
      var d2 = document.querySelector('[data-filter-drawer]');
      if (d2) { d2.classList.remove('is-open'); d2.setAttribute('aria-hidden', 'true'); document.body.classList.remove('filter-open'); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('[data-filter-drawer].is-open');
    if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('filter-open'); }
  });

  /* ---- Collection "Load more" (append next page) ------------------
     The grid is built up client-side, so a plain back-navigation re-renders page 1 and the
     shopper loses their place. Remember how many pages were appended and how far down they
     were — keyed by pathname+search, so every filter/sort combination is remembered
     separately — then replay it when they come back. */
  function lmKey() { return 'fc-lm:' + location.pathname + location.search; }
  function lmRead() { try { return JSON.parse(sessionStorage.getItem(lmKey()) || 'null'); } catch (e) { return null; } }
  function lmWrite(s) { try { sessionStorage.setItem(lmKey(), JSON.stringify(s)); } catch (e) { /* private mode */ } }

  /* The title tile sits in a grid cell on page 1, so a full page of products leaves one card
     stranded on a row of its own. Liquid's paginate uses ONE page size for every page, so a
     shorter first page cannot be expressed there — page 2 would still start at N+1 and product N
     would never appear. Hold it back visually instead: while a Load more button exists, exactly
     one trailing product card is hidden; the next page releases it and holds its own last card.
     First screen = per_page - 1, every Load more = exactly per_page, nothing skipped.
     Matches .prod-card, NOT the last grid child — the filters box, title tile and promo tiles are
     grid children too and any of them can be last. */
  function lmHoldOne() {
    var grid = document.querySelector('[data-grid]');
    if (!grid) return;
    var held = grid.querySelector('.prod-card.lm-held');
    if (held) held.classList.remove('lm-held');
    if (!document.querySelector('[data-load-more]')) return;   // last page: show everything
    var cards = grid.querySelectorAll('.prod-card');
    if (cards.length) cards[cards.length - 1].classList.add('lm-held');
  }

  /* Fetch one more page and append it. Returns the NEXT url, or null when exhausted. */
  function lmAppend(url) {
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-grid]');
        var grid = document.querySelector('[data-grid]');
        if (newGrid && grid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (c) { grid.appendChild(c); });
        }
        var newNote = doc.querySelector('[data-loaded-note]');
        var note = document.querySelector('[data-loaded-note]');
        if (newNote && note) note.textContent = newNote.textContent;
        var btn = document.querySelector('[data-load-more]');
        var newBtn = doc.querySelector('[data-load-more]');
        if (btn) {
          if (newBtn) { btn.dataset.url = newBtn.dataset.url; btn.classList.remove('is-loading'); }
          else { var row = btn.closest('.load-more-row'); if (row) row.remove(); }
        }
        lmHoldOne();   // re-assert after the button state settles
        return newBtn ? newBtn.dataset.url : null;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.dataset.url;
    if (!url) return;
    btn.classList.add('is-loading');
    lmAppend(url)
      .then(function () {
        var st = lmRead() || { p: 1, y: 0 };
        st.p = (st.p || 1) + 1;
        lmWrite(st);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  });

  /* Remember the scroll offset on the way out, but only once extra pages exist —
     below that the browser's own restoration is already correct. */
  window.addEventListener('pagehide', function () {
    if (!document.querySelector('[data-grid]')) return;
    var st = lmRead();
    if (!st || !st.p || st.p < 2) return;
    st.y = window.scrollY || document.documentElement.scrollTop || 0;
    lmWrite(st);
  });

  (function lmRestore() {
    var grid = document.querySelector('[data-grid]');
    if (!grid) return;
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
    var isBack = nav ? nav.type === 'back_forward' : false;
    var st = lmRead();
    // A fresh visit starts over, so stale state can never replay later.
    if (!isBack) { if (st) lmWrite({ p: 1, y: 0 }); return; }
    if (!st || !st.p || st.p < 2) return;
    // We place the viewport ourselves once the pages are back in the DOM.
    var prev = ('scrollRestoration' in history) ? history.scrollRestoration : null;
    if (prev !== null) history.scrollRestoration = 'manual';
    var remaining = st.p - 1;
    function finish() {
      window.scrollTo(0, st.y || 0);
      if (prev !== null) history.scrollRestoration = prev;
    }
    function step() {
      var b = document.querySelector('[data-load-more]');
      if (!remaining || !b || !b.dataset.url) { finish(); return; }
      remaining--;
      lmAppend(b.dataset.url).then(step, finish);
    }
    step();
  })();

  // Page 1. Appends re-assert it themselves, including the back-navigation replay.
  lmHoldOne();

  /* ---- Phone model carousel (tabs + arrows) ----------------------- */
  function initPhoneCarousel(root) {
    (root || document).querySelectorAll('.pm-carousel').forEach(function (sec) {
      if (sec.dataset.bound) return;
      sec.dataset.bound = '1';
      var tabs = sec.querySelectorAll('[data-pm-tab]');
      var panels = sec.querySelectorAll('[data-pm-panel]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var key = t.getAttribute('data-pm-tab');
          tabs.forEach(function (x) { x.classList.toggle('active', x === t); x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
          panels.forEach(function (p) {
            var on = p.getAttribute('data-pm-panel') === key;
            p.classList.toggle('active', on);
            p.hidden = !on;
          });
        });
      });
      panels.forEach(function (panel) {
        var track = panel.querySelector('[data-pm-track]');
        if (!track) return;
        var prev = panel.querySelector('[data-pm-prev]');
        var next = panel.querySelector('[data-pm-next]');
        var page = function () { return Math.max(160, track.clientWidth * 0.8); };
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });
      });
    });
  }

  /* ---- Thousands-separate any [data-int] numbers ------------------ */
  function initIntFormat(root) {
    (root || document).querySelectorAll('[data-int]').forEach(function (el) {
      if (el.dataset.intDone) return;
      var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
      if (!isNaN(n)) { el.textContent = n.toLocaleString(); el.dataset.intDone = '1'; }
    });
  }

  function initAll(root) {
    initDrawer(root);
    initCarousels(root);
    initMega(root);
    initPredictiveSearch(root);
    initPhoneCarousel(root);
    initIntFormat(root);
    initScrollers(root);
  }

  /* Generic arrow scroller: [data-scroller] with [data-scroll-track] + prev/next.
     Hides arrows when there's nothing to scroll. Used by the quick filters. */
  window.__fcInitScrollers = function (root) { initScrollers(root); };
  function initScrollers(root) {
    (root || document).querySelectorAll('[data-scroller]').forEach(function (sc) {
      if (sc._fcScroller) return;
      sc._fcScroller = true;
      var track = sc.querySelector('[data-scroll-track]');
      var prev = sc.querySelector('[data-scroll-prev]');
      var next = sc.querySelector('[data-scroll-next]');
      if (!track) return;
      function amount() { return Math.max(120, track.clientWidth * 0.7); }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();


/* ── Tough hover-swap: cards with data-hover-src fade to the Tough mockup on hover (desktop only). ── */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.addEventListener('mouseenter', function (e) {
    var media = e.target && e.target.closest && e.target.closest('[data-hover-src]');
    if (!media || media.__toughHover) return;
    media.__toughHover = true;
    var img = document.createElement('img');
    img.className = 'prod-hover';
    img.alt = '';
    img.addEventListener('load', function () { img.classList.add('is-ready'); });
    img.src = media.getAttribute('data-hover-src');
    media.appendChild(img);
  }, true);
})();
